import { createContext, useContext, useEffect, useState } from "react"
import { Outlet } from "react-router-dom";
import setSession from "../utils/helpers/setSession";
import axios from "../utils/axios";
import { useToast } from "./ToastContext";
import * as apiAuth from "../api/apiAuth";

const initState = {
    isLogin: false,
    token:null,
    user: null
};

  
// Створюємо контекст
const AuthContext = createContext();

 
// Хук контексту 
export const useAuth = () => useContext(AuthContext);

// Компонент контейсту
export const AuthProvider = ({children}) => {
 
    const [ auth, setAuth] = useState(initState);
    const [ isReady, setIsReady ] = useState(false);
    const { showToast } = useToast();
   
    // Авторизація через логін та пароль
    const LogIn = async (email, password, accessToken) => {
        try {
            const resLogin = accessToken 
                                ? await apiAuth.loginGoogle({accessToken : accessToken})
                                : await apiAuth.loginLocal({email:email, password:password});  

            if (resLogin?.data?.isLogin !== true) {
                return false;
            }
            setAuth(resLogin?.data); 
            setSession(resLogin?.data?.token);
            return true;
        } catch(e){
            console.log(e);
            showToast('API Error', 'danger') 
            return false;
        } 
    } 

    
   
    // Авторизація через токен (відновлення)
    const LogInByJwt = async (jwt) => {
        try {
            setIsReady(false);
            const resLogin = await apiAuth.loginLocal({jwt:jwt});  
            if (resLogin?.data?.isLogin !== true) LogOut();
            setAuth(resLogin?.data);
            setSession(resLogin?.data?.token);
            setIsReady(true);
        }catch(e){
            console.log(e);
            LogOut();
        }
    }

    // Вихід
    const LogOut = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            setSession(null);
            setAuth(initState);
            const resLogin = await apiAuth.logout({jwt:authToken}); 
        } catch(e) {
            console.log(e)
        }
        
    }

    useEffect(()=>{
        const authToken = localStorage.getItem('authToken');
        LogInByJwt(authToken);
    },[])
 
    return isReady
        ? (<AuthContext.Provider  
            value={{auth, LogIn, LogOut}}>
            {children}
        </AuthContext.Provider>)
        : (<span className="badge text-bg-primary m-2">Loginning...</span>); 
    
}